<template>
  <zg-module
    v-bind="moduleProps"
    class="zg-teaser-section"
  >
    <zg-teaser
      full-width
      :image="image"
      :link-text="button && button.text"
      :url="button && button.href"
      :list="listItems"
      :illustration="illustration"
      :reverse-content="reverseContentWithImage"
      :tracking-object="trackingObject"
    >
      <slot
        slot="text"
        name="text"
      />
    </zg-teaser>
  </zg-module>
</template>

<script>
  import module from '../../../mixins/module.js'
  import ZgTeaser from '../../ZgTeaser/ZgTeaser.vue'
  import ZgModule from '../ZgModule/ZgModule.vue'

  export default {
    name: 'ZgTeaserSection',
    components: {
      ZgModule,
      ZgTeaser
    },
    mixins: [module],
    props: {
      image: {
        type: Object,
        required: false,
        default: null,
        validator: (value) => value.title && value.src
      },
      illustration: {
        type: String,
        required: false,
        default: null
      },
      listItems: {
        type: Array,
        required: false,
        default: null
      },
      button: {
        type: Object,
        default: null,
        validator: (button) => !button || (button.text && button.href)
      },
      reverseContentWithImage: {
        type: Boolean,
        required: false,
        default: false
      },
      trackingObject: {
        type: Object,
        required: false,
        default: null,
        validator: value => value.event && value.category && value.action && value.label
      }
    }
  }
</script>
